<template>
  <div>
    <h3 class="text-gray-700 text-3xl font-medium">Teilnehmer</h3>
  </div>
</template>

<script>

export default {
  name: "Attendees",
  data(){
    return {

    }
  }
}
</script>

<style scoped>

</style>
